/* eslint-disable no-undef */
export default {
	name: "add-edit-product-base-pricing-delivery",
	props:{
		productId:{
			default: null
		}
	},
	data() {
		return {
			productPricingDelivery: {
				product: null,
				productId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				zoneErrorMessage: null,
				zonePricing:[],
				effectiveDate:{
					value: new Date(),
					hasError: false,
					errorMessage: null
				}
			},
			zones: [],
			products: [],
			loading: false,
			isUpdate: false,
			resetPassword: false,
			errorModal:{
				modalHeading: "Error",
				elementId: "productPricingDeliveryModalError",
				modalMessage: "",
				showModal: false
			},
			successModal:{
				modalHeading: "Success",
				elementId: "productPricingDeliveryModalSuccess",
				modalMessage: "",
				showModal: false
			},
			initialiseDate: true
		};
	},
	methods: {
		getProductPricingDelivery(){
			productService.getZoneProductBasePricesByProduct(this.productId, orderHelper.orderType.delivery).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.productPricingDelivery.productId.value = this.productId;
						this.productPricingDelivery.product = successResponse.data.result[0].product;
						this.productPricingDelivery.zonePricing = successResponse.data.result;
						//this.productPricingDelivery.effectiveDate.value = new Date().setDate(new Date().getDate() + 1);
						this.getZones();
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProducts(){
			let request = {
				isActive: true,
				allowDelivery: true
			};
			productService.getProducts(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						this.products = $.map(this.products,
							function (obj) {
								obj.id = obj.id || obj.productId;
								obj.text = obj.text || obj.name;
								return obj;
							});
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getZones(){
			let request = {
				isActive: true
			};
			let fieldsToFilterBy = [
				{
					value: null,
					key: "description"
				},
				// {
				// 	value: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				// 	key: "isActive"
				// }
			];
			let activeOnly = true;
			systemService.getZones(fieldsToFilterBy, request, false, activeOnly).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.zones = successResponse.data.result;
						this.zones = dataTableHelper.castFieldValues(this.zones);
						for(let i = 0; i < this.zones.length; i++){
							this.zones[i].selected = false;
							this.zones[i].price = null;
							this.zones[i].zoneProductBasePriceId = 0;
							for(let j = 0; j < this.productPricingDelivery.zonePricing.length; j++){
								if(this.productPricingDelivery.zonePricing[j].zoneId === this.zones[i].zoneId){
									this.zones[i].price = this.productPricingDelivery.zonePricing[j].price;
									this.zones[i].zoneProductBasePriceId = this.productPricingDelivery.zonePricing[j].zoneProductBasePriceId;
									break;
								}
							}
						}
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onProductSelect(product){
			if(this.productPricingDelivery.productId.value !== product.id){
				this.productPricingDelivery.productId.value = product.id;
			}
		},
		onZoneSelected(zone){
			this.productPricingDelivery.zonePricing = zone;
			console.log("zonePricing", this.productPricingDelivery.zonePricing);
		},
		onEffectiveDateSelect(date){
			this.productPricingDelivery.effectiveDate.value = date;
			this.initialiseDate = false;
		},
		onBackClick(){
			this.$router.go(-1);
		},
		successModalOkClicked(){
			this.successModal = {
				modalHeading: "Success",
				elementId: "productPricingDeliveryModalSuccess",
				modalMessage: "",
				showModal: false
			};
			this.clearModel();
			if(this.isUpdate){
				this.$router.go(-1);
			}
		},
		errorModalOkClicked(){
			this.errorModal = {
				modalHeading: "Error",
				elementId: "productPricingDeliveryModalError",
				modalMessage: "",
				showModal: false
			};
		},
		saveDeliveryPricing(){
			this.loading = true;
			let request = {
				productId: this.productPricingDelivery.productId.value === null ? 0 : this.productPricingDelivery.productId.value,
				productZonePrices: this.productPricingDelivery.zonePricing,
				effectiveDate: this.productPricingDelivery.effectiveDate.value
			};
			productService.addOrUpdateZoneProductBasePrice(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.zoneProductBasePriceValidationResponse.valuesAreValid){
							this.successModal.showModal = true;
							this.successModal.modalMessage = "Pricing Saved Successfully";
						}
						else{
							
							this.productPricingDelivery.productId.errorMessage = successResponse.data.zoneProductBasePriceValidationResponse.productValidationResponse.message;
							this.productPricingDelivery.productId.hasError = successResponse.data.zoneProductBasePriceValidationResponse.productValidationResponse.hasError;

							this.productPricingDelivery.effectiveDate.errorMessage = successResponse.data.zoneProductBasePriceValidationResponse.effectiveDateValidationResponse.message;
							this.productPricingDelivery.effectiveDate.hasError = successResponse.data.zoneProductBasePriceValidationResponse.effectiveDateValidationResponse.hasError;

							this.productPricingDelivery.zoneErrorMessage = successResponse.data.zoneProductBasePriceValidationResponse.zonePricingValidationResponse.message;
							console.log("productPricingDelivery.productId", this.productPricingDelivery.productId)
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearModel(){
			this.productPricingDelivery = {
				productId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				zoneErrorMessage: null,
				zonePricing:[],
				effectiveDate:{
					value: null,
					hasError: false,
					errorMessage: null
				}
			};
			for(let i = 0; i < this.zones.length; i++){
				this.zones[i].selected = false;
				this.zones[i].price = null;
			}
		},
		setBreadcrumbs() {
			var pageTitle = "Add Product Base Pricing";
			if(this.productId != null && this.productId > 0){
				pageTitle = "Edit Product Base Pricing";
			}
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getProducts();
	},
	watch: {
		productId: {
			handler: function () {
				if (this.productId !== null && this.productId > 0) {
					this.isUpdate = true;
					this.getProductPricingDelivery();
				}
				else{
					this.isUpdate = false;
					this.getZones();
				}
			},
			immediate: true,
			deep: true
		}
	}
};